import {Navigate, Outlet} from "react-router";

export const ProtectedRouter = ({isLoggedIn}) => {
    return isLoggedIn ? <Outlet/> : <Navigate to={'/'}/>;
}